import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sgzp-app2register-resend',
  templateUrl: './sgzp-app2-register-resend.component.html',
  styleUrls: [
    './sgzp-app2-register-resend.component.css',
    '../style/global.css',
  ],
})
export class SgzpApp2RegisterResendComponent
  extends BaseLoginComponent
  implements OnInit
{
  email: string = '';
  client_id: string;
  private _spinner: NgxSpinnerService;
  constructor(
    activatedRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    spinner: NgxSpinnerService,
    public router: Router,
    public title: Title,
    private http: HttpClient
  ) {
    super(activatedRoute, auth0, dxauth, spinner, router, title);
    this._spinner = spinner;
    activatedRoute.queryParams.subscribe((query) => {
      this.client_id = query['client_id'];
    });
  }

  get isSubmitable() {
    if (!this.email.length) return false;
    if (this.email) {
      const match = this.email.match(/^.*@.*\..+$/);
      return match;
    }
    return true;
  }

  async submit() {
    if (!this.isSubmitable) return;
    this._spinner.show();
    try {
      this.http
        .post(
          `https://${environment.domain}/management/api/v1/auth/verification-email`,
          {
            client_id: this.client_id,
            email: this.email,
          }
        )
        .subscribe((resp: { result: boolean }) => {
          this._spinner.hide();
          if (!resp.result) {
            return;
          }
          sessionStorage.setItem(sessionStorageKey.verifyEmail, this.email);
          // メール送信ページへ飛ばす
          location.pathname = 'register-send';
        });
    } catch (error) {
      this._spinner.hide();
    }
  }

  back() {
    history.back();
  }
}
